var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgShareGuests(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 22.134,
    height: 19.982,
    viewBox: "0 0 22.134 19.982",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "allguests-icon",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_15232",
    "data-name": "Group 15232"
  }, /*#__PURE__*/React.createElement("g", {
    id: "icons_User_Line",
    "data-name": "icons/User/Line",
    transform: "translate(13.145 4.819)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Shape",
    d: "M5.223,1.131A3.027,3.027,0,0,0,2.4,3.211L1.473,2.086A4.03,4.03,0,0,1,5.223,0a5.088,5.088,0,0,1,5.088,5.088V6.219a.565.565,0,0,1-1.131,0V5.088A3.958,3.958,0,0,0,5.223,1.131Z",
    transform: "translate(-1.473 5.654)",
    fill: "#2148ff",
    stroke: "#2148ff",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    id: "Shape-2",
    "data-name": "Shape",
    d: "M3.392,5.654A2.261,2.261,0,1,0,1.131,3.392,2.261,2.261,0,0,0,3.392,5.654Zm0,1.131A3.392,3.392,0,1,0,0,3.392,3.392,3.392,0,0,0,3.392,6.784Z",
    transform: "translate(0.358 0)",
    fill: "#2148ff",
    stroke: "#2148ff",
    strokeWidth: 0.3,
    fillRule: "evenodd"
  })), /*#__PURE__*/React.createElement("g", {
    id: "icons_User_Line-2",
    "data-name": "icons/User/Line"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Shape-3",
    "data-name": "Shape",
    d: "M8.175,1.817A6.358,6.358,0,0,0,1.817,8.175V9.991A.908.908,0,0,1,0,9.991V8.175a8.175,8.175,0,0,1,16.349,0V9.991a.908.908,0,0,1-1.817,0V8.175A6.358,6.358,0,0,0,8.175,1.817Z",
    transform: "translate(0 9.083)",
    fill: "#2148ff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Shape-4",
    "data-name": "Shape",
    d: "M5.45,9.083A3.633,3.633,0,1,0,1.817,5.45,3.633,3.633,0,0,0,5.45,9.083Zm0,1.817A5.45,5.45,0,1,0,0,5.45,5.45,5.45,0,0,0,5.45,10.9Z",
    transform: "translate(2.725 0)",
    fill: "#2148ff",
    fillRule: "evenodd"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgShareGuests);
export default __webpack_public_path__ + "static/media/shareGuests.7099df42e0dbfe77690467cbd39e4299.svg";
export { ForwardRef as ReactComponent };